













































































































import { getModule } from "vuex-module-decorators";
import { Component, Vue, Prop } from "vue-property-decorator";
import PacketizationDiagramConfig from "./data/PacketizationDiagramConfig";
import * as qlog from '@/data/QlogSchema';

import ConnectionConfigurator from "@/components/shared/ConnectionConfigurator.vue";
import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";
import Connection from "@/data/Connection";
import QlogConnection from '@/data/Connection';

@Component({
    components: {
        ConnectionConfigurator,
    },
})
export default class PacketizationDiagramConfigurator extends Vue {
    @Prop()
    public config!: PacketizationDiagramConfig;

    public store:ConnectionStore = getModule(ConnectionStore, this.$store);

    protected infoShown:boolean = false;

    public onConnectionSelected(connection:Connection) {
        console.log("PacketizationDiagramConfigurator:onConnectionSelected : ", this.config, connection);

        this.config.connections = [ connection ];
    }

    public get allowSelectAll() : boolean {
        return (window.location.toString().indexOf(":8080") >= 0 ); // only for local testing for now! // TODO: CLEAN UP
    }

    public selectAllConnections() {

        // TODO: just for paper results, remove!
        (window as any).holblockinfo = new Array<any>();

        const conns = [];
        for ( const group of this.store.groups ){
            if ( group.filename.indexOf("DEMO") < 0 ){
                conns.push( ...group.getConnections() );
            }
        }

        this.config.connections = conns;
    }

    public mounted(){
        if ( this.config.connections.length === 0 && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    public updated(){
        if ( this.config.connections.length === 0 && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    protected selectDefault(){
        console.log("PacketizationDiagramConfigurator:selectDefault: adding new default connection configurator", this.store.groups);
        this.config.connections = [ this.store.groups[0].getConnections()[0] ];
    }

    protected toggleInfo() {
        if ( !this.infoShown) {
            this.$bvModal.show("info-modal");
        }
        else {
            this.$bvModal.hide("info-modal");
        }

        this.infoShown = !this.infoShown;
    }
}

